import React from "react";
import {
	Box,
	Button,
	Grid,
	Paper,
	Typography,
	TextField as MuiTextField,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

export const PalletFilters = ({
	filters,
	translate,
	onFilterChange,
	onApplyFilters,
	onClearFilters,
	classes,
}) => {
	return (
		<Paper className={classes.filterContainer}>
			<Typography variant="subtitle1" gutterBottom>
				{translate("tab.pallets.filter.fitler_pallets")}
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.sscc")}
						value={filters.sscc}
						onChange={(e) => onFilterChange("sscc", e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.gtin")}
						value={filters.gtin}
						onChange={(e) => onFilterChange("gtin", e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.production_date")}
						type="date"
						value={filters.production_date}
						onChange={(e) => onFilterChange("production_date", e.target.value)}
						fullWidth
						size="small"
						InputLabelProps={{ shrink: true }}
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.expiration_date")}
						type="date"
						value={filters.expiration_date}
						onChange={(e) => onFilterChange("expiration_date", e.target.value)}
						fullWidth
						size="small"
						InputLabelProps={{ shrink: true }}
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.external_id")}
						value={filters.ext_id}
						onChange={(e) => onFilterChange("ext_id", e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={4}>
					<MuiTextField
						label={translate("tab.pallets.product_code")}
						value={filters.ext_product_code}
						onChange={(e) => onFilterChange("ext_product_code", e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid>
				<Grid item xs={12}>
					<MuiTextField
						label={translate("tab.pallets.product_description")}
						value={filters.ext_product_description}
						onChange={(e) => onFilterChange("ext_product_description", e.target.value)}
						fullWidth
						size="small"
					/>
				</Grid>
			</Grid>
			<Box mt={2} display="flex" gap={1}>
				<Button variant="contained" color="primary" onClick={onApplyFilters} size="small">
					{translate("tab.pallets.filter.apply_filters")}
				</Button>
				<Button variant="outlined" onClick={onClearFilters} startIcon={<ClearIcon />} size="small">
					{translate("tab.pallets.filter.clear_all")}
				</Button>
			</Box>
		</Paper>
	);
};
